import { FONT_BASIC } from "constants/color";
import "./clearfix.css";

window.document.documentElement.style.color = FONT_BASIC;
window.document.documentElement.style.fontFamily = "Spoqa Han Sans, Spoqa Han Sans JP, Noto Sans KR, Apple SD Gothic Neo, sans-serif";
